import { Component } from '../../../../utils';

@Component({
    controllerAs: 'vm',
    template: require('./circleProgressBar.tpl.html'),
    bindings: {
        circleSize: '@',
        completed: '<',
        textOffset: '@',
        offsetValue: '@'
    }
})
export default class CircleProgressBarComponent {
}



// WEBPACK FOOTER //
// ./src/app/common/components/circleProgressBar/circleProgressBar.js